import { useState } from "react";
import { BiCopy, BiCopyAlt } from "react-icons/bi";

export default function GridDataCopyCell(items) {
  const [showButton, setShowButton] = useState(false);
  const [copied, setCopied] = useState(false);

  const textToCopy = items.dataItem[items.field];

  const handleCopy = async () => {
    await navigator.clipboard.writeText(textToCopy);
    setCopied(true);
  };

  return (
    <td className="k-table-td" {...items?.tdProps}>
      <button
        type="button"
        className="relative w-full h-full text-left bg-transparent border-none p-0"
        title={copied ? "Copied" : "Copy to clipboard"}
        aria-label={copied ? "Copied" : `Copy ${textToCopy} to clipboard`}
        onClick={handleCopy}
        onMouseEnter={() => setShowButton(true)}
        onMouseLeave={() => {
          setShowButton(false);
          setCopied(false);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleCopy();
          }
        }}
        onBlur={() => setCopied(false)}
      >
        {/* Cell text content */}
        <div className="w-full pr-8">
          {items?.customCell ? items.customCell : textToCopy}
        </div>

        {/* Fixed-size top-right icon container */}
        <div
          className={`absolute top-0 right-0 flex items-center justify-center w-6 h-6 m-1 rounded-md bg-white transition-opacity duration-200 ${
            showButton ? "opacity-100" : "opacity-0"
          }`}
        >
          {copied ? (
            <BiCopyAlt
              className="text-gray-700 text-[14px] cursor-pointer"
              aria-hidden="true"
            />
          ) : (
            <BiCopy
              className="text-gray-700 text-[14px] cursor-pointer"
              aria-hidden="true"
            />
          )}
        </div>
      </button>
    </td>
  );
}
